import { useRef, useEffect } from "react";
import styles from "./css/MessageBox.module.css";
import { ChatDto } from "../interfaces/chat.interface";

interface MessageBoxProps {
  messages: ChatDto[];
  loginId: number;
}

export default function MessageBox({ messages, loginId }: MessageBoxProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      const scrollHeight = containerRef.current.scrollHeight;
      containerRef.current.scrollTo({
        top: scrollHeight,
        behavior: "smooth",
      });
    }
  }, [messages]);

  const formatTime = (timestamp: string) => {
    const date = new Date(timestamp);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "오후" : "오전";
    const formattedHours = hours % 12 || 12;
    return `${ampm} ${formattedHours}:${minutes.toString().padStart(2, "0")}`;
  };

  return (
    <div className={styles.messageContainer} ref={containerRef}>
      {messages.map((msg, index) => {
        const isMyMessage = Number(msg.userId) === Number(loginId);
        return (
          <div
            key={index}
            className={`${styles.messageRow} ${
              isMyMessage ? styles.myMessage : styles.otherMessage
            }`}
          >
            {isMyMessage ? (
              <>
                <div className={styles.messageWrapper}>
                  <span className={styles.timestamp}>
                    {formatTime(msg.timestamp)}
                  </span>
                  <div className={styles.myMessageContent}>
                    <div className={styles.nickname}>{msg.nickname}</div>
                    <div className={styles.message}>{msg.message}</div>
                  </div>
                  <div className={styles.userImage}>
                    <img src={msg.characterImageUrl} alt={msg.nickname} />
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className={styles.messageWrapper}>
                  <div className={styles.userImage}>
                    <img
                      src={msg.characterImageUrl}
                      alt={msg.nickname}
                      className={styles.characterImage}
                    />
                  </div>
                  <div className={styles.otherMessageContent}>
                    <div className={styles.nickname}>{msg.nickname}</div>
                    <div className={styles.message}>{msg.message}</div>
                  </div>
                  <span className={styles.timestamp}>
                    {formatTime(msg.timestamp)}
                  </span>
                </div>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
}
